<input [value]="element._get('data')" [readonly]="element._get('readOnly')">
